import { Link } from "react-router-dom";

const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;

export default function RedirectPage() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  if (code) {
    const edgeUrl = `${SUPABASE_URL}/functions/v1/qr-redirect?code=${encodeURIComponent(code)}`;
    window.location.replace(edgeUrl);
    return null;
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-6 bg-amber-50 rounded-2xl flex items-center justify-center">
          <i className="ri-error-warning-line text-4xl text-amber-500" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 mb-2">
          Bir Sorun Oluştu
        </h1>
        <p className="text-sm text-slate-500 mb-6">
          Kod parametresi eksik. Lütfen geçerli bir QR kodu tarayın.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line" />
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
}
